// extracted by mini-css-extract-plugin
export default {"question-body":"quizItem_question-body__7vyL3","answers":"quizItem_answers__P0KyU","answer":"quizItem_answer__Zp6Fb"};